var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 41,
    height: 41,
    rx: 20.5,
    fill: "#FAEF9B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 12.25V12.9531C24.8125 13.4219 27 15.8828 27 18.8125V20.1406C27 21.8984 27.5859 23.6172 28.6797 25.0234L29.2656 25.7266C29.5 26.0391 29.5391 26.4297 29.3828 26.7422C29.2266 27.0547 28.9141 27.25 28.5625 27.25H12.9375C12.5469 27.25 12.2344 27.0547 12.0781 26.7422C11.9219 26.4297 11.9609 26.0391 12.1953 25.7266L12.7812 25.0234C13.875 23.6172 14.5 21.8984 14.5 20.1406V18.8125C14.5 15.8828 16.6484 13.4219 19.5 12.9531V12.25C19.5 11.5859 20.0469 11 20.75 11C21.4141 11 22 11.5859 22 12.25ZM20.4375 14.75C18.1719 14.75 16.375 16.5859 16.375 18.8125V20.1406C16.375 22.0156 15.8281 23.8125 14.8125 25.375H26.6484C25.6328 23.8125 25.125 22.0156 25.125 20.1406V18.8125C25.125 16.5859 23.2891 14.75 21.0625 14.75H20.4375ZM23.25 28.5C23.25 29.1641 22.9766 29.8281 22.5078 30.2969C22.0391 30.7656 21.375 31 20.75 31C20.0859 31 19.4219 30.7656 18.9531 30.2969C18.4844 29.8281 18.25 29.1641 18.25 28.5H23.25Z",
    fill: "#D9C423"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.6f5e6fd8095b04e48ba72a5dafa2ba81.svg";
export { ForwardRef as ReactComponent };